// extracted by mini-css-extract-plugin
export default {"background":"Container_background__IjZky","container":"Container_container__xDKWc"};